"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteServerImpl = void 0;
var remote_servers_1 = require("./../../../features/remote-servers");
var RemoteServerImpl = /** @class */ (function () {
    function RemoteServerImpl(type, name, urls, principal, connectionOptions, missingTopicNotificationFilter, connector) {
        this.type = type;
        this.name = name;
        this.urls = urls;
        this.url = urls[0];
        this.primaryHostName = urls[0];
        this.principal = principal;
        this.connectionOptions = connectionOptions;
        this.missingTopicNotificationFilter = missingTopicNotificationFilter;
        this.connector = connector;
    }
    RemoteServerImpl.prototype.getRetryDelay = function () {
        var retryDelay = this.connectionOptions[remote_servers_1.ConnectionOption.RETRY_DELAY];
        return retryDelay === undefined ? 1000 : Number.parseInt(retryDelay, 10);
    };
    return RemoteServerImpl;
}());
exports.RemoteServerImpl = RemoteServerImpl;
